import { render, staticRenderFns } from "./AddTagBox.template.vue?vue&type=template&id=0a481814&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a481814",
  null
  
)

export default component.exports